import React from 'react';
import { useTranslations } from 'next-intl';
import appRoutes from '@/constants/routes';
import AfiwaButton from '@/ui/shared/components/afiwaButton';
import { ArrowRightIcon } from '@heroicons/react/24/outline';

function Commissions() {
  const affiliateProgramText = useTranslations('affiliate_program.commission');

  return (
    <div className="md:app-container bg-second-gradient my-16 flex h-full flex-col items-center justify-center gap-y-5 rounded-xl p-10 text-white sm:gap-y-10 md:my-20  md:flex-row md:justify-around md:p-5 md:px-10 md:py-16">
      <p className="flex flex-col items-center justify-center">
        <span className="text-2xl font-extrabold md:text-xl lg:text-3xl">
          %
        </span>
        <span className="font-medium  decoration-solid md:text-sm lg:text-base">
          {`${affiliateProgramText('commission')}`}
        </span>
      </p>
      <p className="max-w-md text-center text-sm font-semibold md:max-w-xs md:text-left md:text-xs lg:max-w-md lg:text-sm">
        {affiliateProgramText('earn_commission')}
      </p>
      <AfiwaButton
        type="primary"
        size="large"
        className=" block !max-w-xs   !bg-white !text-xs !font-semibold !text-primary"
        href={appRoutes.signup}
        text={affiliateProgramText('become_affiliate')}
        rightIcon={
          <ArrowRightIcon height={15} width={15} className="text-primary" />
        }
      />
    </div>
  );
}

export default Commissions;
